import { combineReducers, AnyAction } from '@reduxjs/toolkit';

import {
  announcementReducer,
  mediaQueryReducer,
  OrderBumpFormReducer,
  orderBumpPreviewReducer,
  userReducer
} from './features';
import initialState from './initialState';

const appReducer = combineReducers({
  user: userReducer,
  mediaQuery: mediaQueryReducer,
  orderBumpForm: OrderBumpFormReducer,
  orderBumpPreview: orderBumpPreviewReducer,
  announcement: announcementReducer
});

export const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === 'RESET') {
    return initialState;
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof appReducer>;

export default rootReducer;
